module.exports = __webpack_public_path__ + "img/category-Thriller.117cc5f9.svg";